module.exports = __webpack_public_path__ + "static/media/back.4e149e2d.svg";